export const ru = {
  dashboard: {
    overview: 'Übersicht',
  },
  common: {
    languageChanged: 'Sprache geändert',
  },
  translations: {
    server:
      'Diese Nachricht wird dynamisch auf dem Next.js-Server generiert und von einer React-Server-Komponente für eine schnelle und nahtlose Benutzererfahrung gerendert.',
    client:
      'Diese Nachricht wird von einer React-Client-Komponente gerendert und zeigt interaktive Elemente und dynamische Aktualisierungen ohne vollständige Seitenneuladen.',
  },
  navigation: {
    dashboard: 'الرئيسية',
  },
} as const;
